function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m0.5 156.47h74v38h-74v103h74v38h-74v102h74v40h-74v102h74v38h-74v103h74v38h-74v102h74v40h-74v67c0.03 20.4 14.95 33.76 35 34h928c19.18-0.03 36.75-11.25 37-32 0.21-18.6-7.69-22.69-20-35l-26-26-890-890c-9.31-9.31-14.87-17.04-29-17.91-19.73-1.21-34.97 14.62-35 33.91zm187 235.33c5.59-0.62 13.71-0.73 19 1.23 8.27 3.06 20.37 16.81 27 23.44 125.08 125.88 228.64 227.64 354 353 11.15 11.15 22.92 20 23.91 37 1.06 18.23-15.33 32.79-32.91 33h-381c-5.25-0.01-7.9-0.07-13-1.75-12.79-4.19-21.83-15.72-22-29.25v-388c0.18-14.86 11.06-25.37 25-28.67z",
  stroke: "none"
});

var SvgSurface2 = function SvgSurface2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000",
    width: "264.85mm",
    height: "265.11mm",
    viewBox: "0 0 1001.0041 1001.9749",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSurface2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/surface2.72bd8b1c.svg";
export { ForwardRef as ReactComponent };